import React, { forwardRef, useEffect, useRef} from 'react';
import MaterialTable, { MTableBody } from 'material-table';

import { AddBox, DeleteOutline, Edit, Check, Clear,
   ArrowDownward, ChevronLeft, ChevronRight,
   FirstPage, LastPage,
   Remove, FilterList, Search, SaveAlt, ViewColumn, FilterAltOutlined} from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (<ChevronRight {...props} ref={ref} />)),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (<ChevronLeft {...props} ref={ref} />)),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export default function TableComponent({columns, data, canEdit, onRowAdd, onRowUpdate, onRowDelete, onDeleteLabel, ...props}) {
  const [openAlert, setOpenAlert] = React.useState(false);
  const tableRef = useRef();

  const AlertDialog = (props) => {
    const { open, setOpen, message } = props;

    const handleClose = () => {
      setOpen(false);
    };

    return (
      <Dialog open={open}>
        <DialogTitle>Ошибка</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>OK</Button>
        </DialogActions>
      </Dialog>
    )
  }

  useEffect(() => {
    if (props.errorMsg !== undefined && props.errorMsg !== "")
      setOpenAlert(true);
  }, [props.errorMsg])

  
  return (
		<>
			<MaterialTable
				{...props}
				tableRef={props.tableRef}
				style={{ width: "100%" }}
				localization={{
					header: {
						actions: "",
					},
					body: {
						emptyDataSourceMessage: "",
						editRow: {
							saveTooltip: "Подтвердить",
							cancelTooltip: "Отменить",
							deleteText: "Вы уверены, что хотите удалить запись?",
						},
						addTooltip: "Добавить",
						editTooltip: "Редактировать",
						deleteTooltip: "Удалить",
					},
					toolbar: {
						searchTooltip: "Поиск",
						searchPlaceholder: "Поиск",
					},
					pagination: {
						nextTooltip: "Следующая страница",
						previousTooltip: "Предыдущая страница",
						firstTooltip: "Первая страница",
						lastTooltip: "Последняя страница",
						labelRowsSelect: "строк",
						labelDisplayedRows: "{from}-{to} из {count}",
					},
				}}
				icons={tableIcons}
				data={data}
				columns={columns}
				options={{
					showTitle: false,
					draggable: false,
					addRowPosition: "first",
					pageSizeOptions: [10, 25, 100],
					pageSize: 10,
					emptyRowsWhenPaging: false,
					// tableLayout: "fixed",
					headerStyle: {
						textAlign: "center",
					},
					...props.options,
				}}
				editable={{
					onRowAdd: canEdit && onRowAdd ? (newData) => onRowAdd(newData, props.type) : undefined,
					onRowAddCancelled: props.onRowAddCancelled ? (rowData) => props.onRowAddCancelled(rowData): undefined,
					isEditable: props.isEditable,
					isEditHidden: props.isEditHidden,
					onRowUpdate: canEdit && onRowUpdate ? (newData) => onRowUpdate(newData) : undefined,
					isDeletable: props.isDeletable,
					isDeleteHidden: props.isDeleteHidden,
					onRowDelete: canEdit && onRowDelete ? (oldData) => onRowDelete(oldData) : undefined,
				}}
				components={{
					Body: (props) => {
						let _props = props;
						const editingRow = tableRef.current?.state?.lastEditingRow;
						if (onDeleteLabel && editingRow) {
							_props = {
								...props,
								localization: {
									...props.localization,
									editRow: {
										...props.editRow,
										deleteText: onDeleteLabel(editingRow, props.localization.editRow.deleteText),
									},
								},
							};
						}

						return <MTableBody {..._props} />;
					},
				}}
			/>
			<AlertDialog open={openAlert} setOpen={setOpenAlert} message={props.errorMsg} />
		</>
	);
}